export enum InvalidEmailEntryReasonType {
  GameInviteAlreadyGameAdminForCurrentGame = 1,
  OrgInviteAlreadyOrgAdminForAssociatedOrg = 2,
  GameInviteAlreadyHigherAdmin = 3,
  OrgInviteAlreadyCausableAdmin = 4,
  CausableInviteAlreadyCausableAdmin = 5,
  UserIsCurrentlyDeactivated = 6,
  IsNotAdmin = 7
}
